import { connect, useDispatch } from 'react-redux';
import { partoAction, fazendaAction, logAction } from '../_actions';
import React, { useState, useEffect } from 'react';
import NavBar from '../_components/navbar';
import { withRouter } from '../_helpers/withRouter';
import { Button, Container, Row, Col, Card, CardBody, UncontrolledTooltip, Input, Badge, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Moment from 'react-moment';
import { ModalLog } from '../log/';
import 'moment-timezone';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash, faPlusCircle, faSearch, faTimes, faChevronLeft, faChevronRight, faVenusMars, faMicroscope, faHistory, faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { authActions } from '../_actions';
import { useNavigate } from 'react-router-dom';

const Parto = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const [selectedFazenda, setSelectedFazenda] = useState('0');
    const [term, setTerm] = useState('');
    const [brinco, setBrinco] = useState('');

    // Pagination state
    const [page, setPage] = useState(1);
    const [limit] = useState(12);

    // Delete validation state
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const toggle = () => setModal(!modal);
    const { log } = props.log;
    const { parto } = props.parto;

    useEffect(() => {
        dispatch(fazendaAction.getFazendaSelect(true));
    }, []);

    useEffect(() => {
        if (selectedFazenda && selectedFazenda !== '0') {
            dispatch(partoAction.getPartoByFazenda(selectedFazenda, true));
        }
        else {
            dispatch(partoAction.clear());
        }
        setPage(1);
    }, [selectedFazenda]);

    const handleChange = event => {
        setTerm(event.target.value);
        setPage(1);
    };

    const handleSelectChange = prop => event => {
        if (prop === 'id_fazenda') {
            setSelectedFazenda(event.value);
        }
        var event2 = {
            type: 'select',
            target: { value: event.value }
        };
        dispatch(fazendaAction.onChangeProps(prop, event2));
    };

    const confirmDelete = (id) => {
        setItemToDelete(id);
        setDeleteModalOpen(true);
    };

    const handleDelete = () => {
        if (itemToDelete) {
            dispatch(partoAction.deletePartoById(itemToDelete, true, selectedFazenda));
            setDeleteModalOpen(false);
            setItemToDelete(null);
        }
    };

    const handleClickHistory = (event, id, brinco) => {
        if (id) {
            setBrinco(brinco);
            dispatch(logAction.getLog('Parto', id));
            toggle();
        }
    };

    const renderOptionsFazenda = () => {
        return props.fazenda.fazenda.map((p, i) => {
            return (
                { value: p.id, label: p.nome }
            );
        });
    };

    const getTipoLabel = (tipo) => {
        switch (tipo) {
            case 'A': return 'Aborto';
            case 'I': return 'Indução';
            case 'M': return 'Macho';
            case 'F': return 'Fêmea';
            case 'MF': return 'Gêmeos Machos';
            case 'FF': return 'Gêmeas Fêmeas';
            default: return 'Desconhecido';
        }
    };

    const getTipoColor = (tipo) => {
        switch (tipo) {
            case 'A': return 'danger';
            case 'I': return 'warning';
            case 'M': return 'primary';
            case 'F': return 'pink'; // Custom class or inline style needed for pink
            default: return 'info';
        }
    };

    // Client-side Filtering
    const filteredPartos = parto ? parto.filter((item) => {
        if (!term) return true;
        const lowerTerm = term.toLowerCase();
        const tipoLabel = getTipoLabel(item.parto.tipo).toLowerCase();
        return tipoLabel.includes(lowerTerm) ||
            (item.brinco || '').toLowerCase().includes(lowerTerm);
    }) : [];

    // Client-side Pagination
    const totalItems = filteredPartos.length;
    const totalPages = Math.ceil(totalItems / limit);
    const paginatedPartos = filteredPartos.slice((page - 1) * limit, page * limit);

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingBottom: '60px' }}>
            <NavBar {...props} />
            <Container className="py-5">
                {/* Header Section */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-5">
                    <div className="mb-3 mb-md-0">
                        <h2 className="font-weight-bold text-dark mb-1">Partos</h2>
                        <p className="text-muted mb-0">Gerencie os registros de nascimentos</p>
                    </div>

                    <div className="d-flex align-items-center flex-column flex-sm-row">
                        <div className="position-relative mr-0 mr-sm-3 mb-3 mb-sm-0 w-100" style={{ minWidth: '250px' }}>
                            <Select
                                classNamePrefix="select"
                                value={renderOptionsFazenda().filter(option => option.value == (selectedFazenda || ''))}
                                onChange={handleSelectChange('id_fazenda')}
                                isSearchable
                                id="id_fazenda"
                                name="id_fazenda"
                                placeholder="Selecione a Fazenda..."
                                options={renderOptionsFazenda()}
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        borderRadius: '50px',
                                        border: state.isFocused ? '1px solid var(--primary-color)' : '1px solid #e0e0e0',
                                        boxShadow: state.isFocused ? '0 0 0 0.2rem var(--primary-shadow)' : '0 2px 4px rgba(0,0,0,0.02)',
                                        paddingLeft: '10px',
                                        height: '45px'
                                    })
                                }}
                            />
                        </div>

                        {selectedFazenda !== '0' && (
                            <>
                                <div className="position-relative mr-0 mr-sm-3 mb-3 mb-sm-0 w-100" style={{ maxWidth: '300px' }}>
                                    <Input
                                        id="term"
                                        placeholder="Buscar por brinco ou tipo..."
                                        value={term}
                                        onChange={handleChange}
                                        style={{
                                            paddingLeft: '40px',
                                            borderRadius: '50px',
                                            border: '1px solid #e0e0e0',
                                            backgroundColor: '#fff',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
                                            height: '45px'
                                        }}
                                    />
                                    <FontAwesomeIcon
                                        icon={faSearch}
                                        className="text-muted position-absolute"
                                        style={{ left: '15px', top: '50%', transform: 'translateY(-50%)' }}
                                    />
                                    {term && (
                                        <FontAwesomeIcon
                                            icon={faTimes}
                                            className="text-muted position-absolute cursor-pointer"
                                            onClick={() => { setTerm(''); setPage(1); }}
                                            style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}
                                        />
                                    )}
                                </div>

                                <Button
                                    id="btnNovo"
                                    color="primary"
                                    className="btn-rounded px-4 shadow-sm border-0 d-flex align-items-center"
                                    style={{ borderRadius: '50px', fontWeight: '600', height: '45px', backgroundColor: 'var(--primary-color)' }}
                                    onClick={() => navigate("/parto")}
                                >
                                    <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
                                    <span className="text-nowrap">Novo Parto</span>
                                </Button>
                                <UncontrolledTooltip placement="bottom" target="btnNovo">
                                    Adicionar novo registro de parto
                                </UncontrolledTooltip>
                            </>
                        )}
                    </div>
                </div>

                {/* Grid Section */}
                {paginatedPartos.length > 0 ? (
                    <>
                        <Row>
                            {paginatedPartos.map((item, index) => (
                                <Col xs={12} md={6} lg={4} className="mb-4" key={index}>
                                    <Card className="h-100 border-0 shadow-sm hover-cards" style={{ borderRadius: '16px', overflow: 'hidden', transition: 'all 0.3s ease' }}>
                                        <CardBody className="p-4 d-flex flex-column">

                                            <div className="d-flex align-items-center mb-4">

                                                <div style={{ overflow: 'hidden' }}>
                                                    <h5 className="mb-1 font-weight-bold text-dark text-truncate">
                                                        {(item.brinco || 'N/D').toUpperCase()}
                                                    </h5>
                                                </div>
                                            </div>

                                            <div className="mb-4 flex-grow-1">
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faCalendarAlt} className="text-muted" />
                                                    </div>
                                                    <span className="d-flex justify-content-between w-100">
                                                        <span>Data:</span>
                                                        <span className="font-weight-bold">
                                                            <Moment format="DD/MM/YYYY">
                                                                {item.parto.data}
                                                            </Moment>
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faVenusMars} className="text-muted" />
                                                    </div>
                                                    <span className="d-flex justify-content-between w-100">
                                                        <span>Sexo:</span>
                                                        <span className="font-weight-bold">
                                                            {getTipoLabel(item.parto.tipo)}
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center text-secondary mb-2">
                                                    <div style={{ width: '24px', textAlign: 'center' }} className="mr-2">
                                                        <FontAwesomeIcon icon={faMicroscope} className="text-muted" />
                                                    </div>
                                                    <span className="d-flex justify-content-between w-100">
                                                        <span>Embrião:</span>
                                                        <span className={`font-weight-bold ${item.id_embriao ? 'text-success' : 'text-muted'}`}>
                                                            {item.id_embriao ? 'SIM' : 'NÃO'}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="mt-auto pt-3 border-top d-flex justify-content-between align-items-center">
                                                <Button
                                                    color="link"
                                                    className="text-decoration-none p-0 text-muted d-flex align-items-center"
                                                    onClick={(event) => handleClickHistory(event, item.parto.id, item.brinco)}
                                                    title="Histórico"
                                                >
                                                    <div className="bg-light rounded-circle d-flex align-items-center justify-content-center mr-2" style={{ width: '32px', height: '32px' }}>
                                                        <FontAwesomeIcon icon={faHistory} size="sm" />
                                                    </div>
                                                    <span className="small font-weight-bold">Histórico</span>
                                                </Button>

                                                <div className="d-flex">
                                                    <Button
                                                        color="primary"
                                                        className="d-flex align-items-center justify-content-center mr-2 rounded-circle shadow-sm border-0"
                                                        style={{ width: '38px', height: '38px', padding: 0, backgroundColor: 'var(--primary-color)' }}
                                                        component='a'
                                                        href={`/parto/${item.parto.id}`}
                                                        title="Editar"
                                                    >
                                                        <FontAwesomeIcon icon={faPen} size="sm" />
                                                    </Button>
                                                    {authActions.isGestor() && (
                                                        <Button
                                                            color="danger"
                                                            className="d-flex align-items-center justify-content-center rounded-circle shadow-sm border-0"
                                                            style={{ width: '38px', height: '38px', padding: 0, backgroundColor: '#e03131' }}
                                                            onClick={() => confirmDelete(item.parto.id)}
                                                            title="Excluir"
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} size="sm" />
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>

                        {/* Pagination */}
                        {totalPages > 1 && (
                            <Row>
                                <Col className="d-flex justify-content-center mt-4 mb-4">
                                    <div className="d-flex align-items-center bg-white shadow-sm rounded-pill px-2 py-1">
                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === 1 ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronLeft} />
                                        </Button>

                                        <span className="mx-3 text-muted font-weight-bold small">
                                            Página {page} de {totalPages}
                                        </span>

                                        <Button
                                            color="link"
                                            className={`rounded-circle text-decoration-none p-0 d-flex align-items-center justify-content-center ${page === totalPages ? 'text-muted' : 'text-primary'}`}
                                            style={{ width: '40px', height: '40px' }}
                                            disabled={page >= totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            <FontAwesomeIcon icon={faChevronRight} />
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </>
                ) : (
                    <Row>
                        <Col className="text-center py-5">
                            <div className="mb-4">
                                <div className="bg-white rounded-circle shadow-sm d-inline-flex align-items-center justify-content-center p-4">
                                    <FontAwesomeIcon icon={faSearch} size="3x" className="text-muted opacity-50" />
                                </div>
                            </div>
                            <h4 className="text-secondary font-weight-bold">Nenhum registro encontrado</h4>
                            <p className="text-muted">Selecione uma fazenda ou ajuste os filtros.</p>
                        </Col>
                    </Row>
                )}
            </Container>

            <ModalLog toggle={toggle} modal={modal} log={log} brinco={brinco} />

            {/* Delete Confirmation Modal */}
            <Modal isOpen={deleteModalOpen} toggle={() => setDeleteModalOpen(false)} centered>
                <ModalHeader toggle={() => setDeleteModalOpen(false)} className="border-0 pb-0"></ModalHeader>
                <ModalBody className="text-center pb-4">
                    <div className="mb-3 text-danger bg-light-danger d-inline-block rounded-circle p-3" style={{ backgroundColor: '#ffebee' }}>
                        <FontAwesomeIcon icon={faTrash} size="2x" />
                    </div>
                    <h4 className="mb-2 font-weight-bold">Excluir Parto</h4>
                    <p className="text-muted mb-4">Tem certeza que deseja excluir este registro? Esta ação não pode ser desfeita.</p>
                </ModalBody>
                <ModalFooter className="border-0 pt-0 justify-content-center pb-4">
                    <Button color="light" onClick={() => setDeleteModalOpen(false)} className="mr-2 rounded-pill px-4 font-weight-bold">Cancelar</Button>
                    <Button color="danger" onClick={handleDelete} className="rounded-pill px-4 font-weight-bold shadow-sm">Confirmar Exclusão</Button>
                </ModalFooter>
            </Modal>

            

            <style>{`
                .hover-cards:hover {
                    box-shadow: 0 10px 25px rgba(0,0,0,0.08) !important;
                    transform: translateY(-4px);
                }
            `}</style>
        </div>
    );
}

const mapStateToProps = (state) => {
    return state;
}
const connectedPartoPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(Parto));
export { connectedPartoPage as Parto };
